"use client";

// Re-export the FractalDotGrid component from bg-animated-fractal-grid.tsx
export { FractalDotGrid } from "./bg-animated-fractal-grid";
